/** Serialises JSON-LD for embedding in a <script> tag. `<` is escaped as \u003c
 * so a value containing "</script>" cannot terminate the script block. The
 * result is still valid JSON and parses back to the same value. */
export function serializeJsonLd(obj: unknown): string {
  return JSON.stringify(obj, null, 2).replace(/</g, "\\u003c");
}

export function isHttpUrl(value: string): boolean {
  try {
    const u = new URL(value.trim());
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

/** Splits "123 Main St, Raleigh, NC 27601" into a PostalAddress. Falls back to
 * the plain string when it does not look like "street, city, region [postcode]". */
export function toPostalAddress(raw: string): string | Record<string, string> {
  const text = raw.trim();
  const parts = text.split(",").map(p => p.trim()).filter(Boolean);
  if (parts.length < 3) return text;
  const last = parts[parts.length - 1];
  const m = last.match(/^([A-Za-z]{2,}(?:\s[A-Za-z]+)*)\s+([A-Za-z0-9][A-Za-z0-9 -]{2,9})$/);
  const addr: Record<string, string> = { "@type": "PostalAddress" };
  if (parts.length >= 4) {
    addr.streetAddress = parts.slice(0, parts.length - 3).join(", ");
    addr.addressLocality = parts[parts.length - 3];
    if (m) { addr.addressRegion = m[1]; addr.postalCode = m[2]; } else addr.addressRegion = last;
    return addr;
  }
  addr.streetAddress = parts[0];
  addr.addressLocality = parts[1];
  if (m) { addr.addressRegion = m[1]; addr.postalCode = m[2]; } else addr.addressRegion = last;
  return addr;
}
